"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHEMKIT_ADDON_FAILED_WINDOW_KEY = exports.CHEMKIT_ADDON_READY_WINDOW_KEY = exports.CHEMKIT_ADDON_FAILED_EVENT = exports.CHEMKIT_ADDON_READY_EVENT = exports.CHEMKIT_ADDON_WAKE_EVENT = void 0;
exports.CHEMKIT_ADDON_WAKE_EVENT = "chemkit.addon.wake";
exports.CHEMKIT_ADDON_READY_EVENT = "chemkit.addon.ready";
exports.CHEMKIT_ADDON_FAILED_EVENT = "chemkit.addon.failed";
exports.CHEMKIT_ADDON_READY_WINDOW_KEY = "__CHEMKIT_ADDON_READY__";
exports.CHEMKIT_ADDON_FAILED_WINDOW_KEY = "__CHEMKIT_ADDON_FAILED__";
